export default {
  contract: {
    searchPlaceholder: '合同编号',
    statusOptions: ['审核', '取消审核'],
    tabOptions: ['未审核', '审核'],
    contractNumber: '合同编号',
    contractName: '合同名称',
    contractType: '合同类型',
    signDate: '签订日期',
    startDate: '生效日期',
    endDate: '失效日期',
    jiaOrganization: '甲方',
    yiOrganization: '乙方',
    contractDesc: '合同描述',
    notifyNumber: '到期提醒天数',
    status: '审核/取消审核',
    audit: '审核',
    cancelAudit: '取消审核',
    statusMessage: ['是否审核?', '是否取消审核?'],
    makeSure: '确认',
    makeSureMessage: '是否确认合同？'
  },
  template: {
    searchPlaceholder: '请输入模板名称查询',
    tabOptions: ['启用', '停用'],
    statusMessage: ['', '是否停用?', '是否启用?'],
    tplNo: '模板编号',
    tplName: '模板名称',
    addByName: '制作者',
    tplDesc: '描述',
    disabledEditor: '启用状态的合同模板不能编辑！',
    disabledDelete: '启用状态的合同模板不能删除！'
  }
}
